import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const nctsResponseContract = c.router({
  postNctsResponse: {
    method: 'POST',
    path: '/ncts-response',
    body: z.record(z.any()),
    responses: {
      200: z.object({ data: z.record(z.any()) }),
    },
  },
});
